import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useApi } from "../use-api";

interface DeleteArgusInstanceInput {
  instanceId: string;
}

export function useDeleteArgusInstance() {
  const queryClient = useQueryClient();
  const { callApi } = useApi<void>();

  return useMutation({
    mutationFn: async (input: DeleteArgusInstanceInput) => {
      await callApi(`/client/argus/instances/${input.instanceId}`, {
        method: "DELETE",
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        predicate: (query) =>
          typeof query.queryKey[0] === "string" &&
          query.queryKey[0].startsWith("/client/argus/instances"),
      });
    },
  });
}
